import i18n from '@/plugins/i18n';
import { cardNames } from '@/components/Database/database.types';
import { BYTES_TO_MB_CONVERSION_VALUE } from '@/utils/templates/databaseTemplate/database.constants';
const hardwarePSGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.cpuUsage'),
      header: {
        title: i18n.global.t('dbm.cpuUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_postgres_cpu_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentagePerMinute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.percentagePerMinute'),
      },
      show: true,
      showForSingleSeries: true,
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.memoryUsage'),
      header: {
        title: i18n.global.t('dbm.memoryUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_postgres_memory_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.networkI/O'),
      header: {
        title: i18n.global.t('dbm.networkI/O'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_postgres_network_bytes_received,meter_postgres_network_bytes_sent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mbPerMinute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.connectionsAndSessions'),
      header: {
        title: i18n.global.t('dbm.connectionsAndSessions'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7', '#ecd5f9', '#856b92'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_postgres_active_connections,meter_postgres_inactive_connections,meter_postgres_sessions,meter_postgres_sessions_abandoned',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnectionsPerMinute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnectionsPerMinute'),
      },
      showLegendForSeries: true,
    },
  ],
  cardComponents: {
    width: '46.3%',
    cardName: Object.values(cardNames),
  },
  StorageCardComponents: {
    storageCards: [
      {
        label: i18n.global.t('dbm.card.cpuStorage'),
        width: '46.3%',
        show: true,
      },
      {
        label: i18n.global.t('dbm.card.memoryStorageinMB'),
        width: '46.3%',
        show: true,
      },
    ],
  },
});

export default hardwarePSGraphs;
